// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"ab7d68ba","648":"d3a5a0f1"}[chunkId] + ".css";
};